export const BRAND_SHOP_ANCHOR_LIST = {
  subBrandSlider: 'aboutyou_router__SUB_BRAND_SLIDER',
};
